import React from 'react';
import { Text } from '@oneaudi/unified-web-components';
import { DangerousElement } from '../../../../../components/DangerousElement';
import { useServicesContext } from '../../../../../context';
import { useFinanceTranslations } from './finance-i18N';
export const FinanceDisclaimerText = ({ formData }) => {
    var _a;
    const { getConfiguration } = useServicesContext();
    const scopesFromConfig = (_a = getConfiguration()) === null || _a === void 0 ? void 0 : _a.scopes;
    const interpretDisclaimerHtml = scopesFromConfig === null || scopesFromConfig === void 0 ? void 0 : scopesFromConfig.interpretDisclaimersTextStyle;
    const renderDisclaimerText = (text) => {
        if (interpretDisclaimerHtml) {
            return React.createElement(DangerousElement, { html: text, as: "span" });
        }
        return React.createElement("span", null, text);
    };
    const i18n = useFinanceTranslations();
    return ((formData === null || formData === void 0 ? void 0 : formData.disclaimer) && (React.createElement(React.Fragment, null,
        React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'bold' } }, renderDisclaimerText(i18n.disclaimerHeadline)),
        formData.disclaimer.productDisclaimer && (React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'normal' } }, renderDisclaimerText(formData.disclaimer.productDisclaimer))),
        formData.disclaimer.globalDisclaimer && (React.createElement(Text, { tag: "p", variant: { type: 'copy', order: '2', style: 'normal' } }, renderDisclaimerText(formData.disclaimer.globalDisclaimer))))));
};
